import { EVENTS } from '@/lib/consts.ts'

export const gtm1Referral = {
  [EVENTS.BUSINESS_REFERRAL_ACTION] ({ data }) {
    return {
      event: 'Business_Referral_Action',
      properties: {
        screen_name: data.screenName,
        event_action: data.eventAction,
        entry_source: data.entrySource ?? null,
        banner_type: data.bannerType ?? null,
      },
    }
  },
}
